// extracted by mini-css-extract-plugin
export default {"icon":"HmgMv1iibd","small":"UgIHJvTkK0","large":"_2dZdxJZGPR","nudgeUp":"YWiSAfMxo6","nudgeDown":"_2pY75zot-s","text-padded-right":"Qt5iskaXhr","textPaddedRight":"Qt5iskaXhr","text-padded-left":"nmHrFakiZw","textPaddedLeft":"nmHrFakiZw"};
    if(module.hot) {
      // 1643570356335
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  